<template><!-- s::PAGE -->

  <div v-if="loading" class="loading"></div>

  <!-- s::PAGE -->
  <div v-else class="contents">
    <!-- s:: MYPAGE -->
    <div class="mypage">
      <div class="layout">
        <div class="box">
          <div ref="sideRef" class="side-box">
            <div class="snb2">
              <MypageSnb/>
            </div>
          </div>

          <div class="content-panel">
            <div class="my-artartist">
              <div class="my-portfolio">
                <div class="title-wrap">
                  <h2 ref="SeeMoreTopRef" class="section-title">PORTFOLIO</h2>
                </div>
                <div class="portfolio-note-banner">
                  <div class="note-header">
                    <div class="note-icon"><img src="@/assets/images/icon/ico_note.svg"></div>
                    <h3 class="note-title">Note</h3>
                  </div>
                  <p class="note-content">
                    <span class="note-pc">
                      포트폴리오 제작 페이지에서 다른 페이지로 이동하는 경우(예: '프로필 관리' 페이지로 이동), <b>내가 작성 중이던 포트폴리오 내용이 초기값으로 설정</b>됩니다.<br>
                      <b>작성 중이던 포트폴리오 세팅과 내용을 저장하고 싶다면</b>, 포트폴리오 미리보기에서 <b>'저장 및 PDF 다운로드'</b>를 꼭 클릭하세요!
                    </span>
                    <span class="note-mo">
                      포트폴리오 제작 페이지에서 다른 페이지로 이동하는 경우, <b>내가 작성 중이던 포트폴리오 내용이 초기값으로 설정.</b><br>
                      <b>작성 중이던 내용을 저장하고 싶다면</b>, 포트폴리오 미리보기에서 <b>'저장 및 PDF 다운로드'</b>를 클릭하세요!
                    </span>
                  </p>

                </div>
                <div class="button-box portfolio-btn portfolio-header">
                  <button
                      v-for="(btn, index) in filteredButtons"
                      :key="btn.id"
                      :class="{ active: selectedIndex === index }"
                      @click="selectButton(index, btn.handler)"
                      style="flex-direction: column; gap: 1px; line-height: 1;"
                  >
                    {{ btn.label }}
                    <template v-if="btn.date"><span>{{ btn.date }}</span></template>
                  </button>
                </div>

                <PortfolioArtistProfile v-if="selectedArtist" :artist="selectedArtist" :field-visibility="fieldVisibility" :reload="reload"/>
                <PortfolioArtistArtWork :art-works="selectedArtWorks" :art-works-portfolio-category="PORTFOLIO"/>

                <div class="button-box portfolio-btn portfolio-footer">
                  <button @click="selectSizeModalVisible = true;" type="button">포트폴리오 크기 설정({{ portfolioTemplateName }})</button>
                  <button @click="openPdfGeneratePanel()" type="button">포트폴리오 파일 생성</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- s:: OUTPUT PORTFOLIO -->

    <PdfGeneratePanel v-if="PdfGeneratePanelVisible"
                      :artist="selectedArtist"
                      :art-works="selectedArtWorks"
                      :pdf-setting-config="pdfSettingConfig"
                      :field-visibility="fieldVisibility"
                      :profile-page-layout-config="profilePageLayoutConfig"
                      :auto-download="pdfAutoDownload"
                      :art-works-portfolio-category="PORTFOLIO"
                      :blob-url-map="blobUrlMap"
                      @downloaded="pdfAutoDownload = false"
                      @close="PdfGeneratePanelVisible=false"
    />
    <!-- @update:field-visibility="val => fieldVisibility = {...val}" -->
    <!-- e:: OUTPUT PORTFOLIO -->

    <!-- s::모달창 등록-->
    <PdfSelectSizeModal v-if="selectSizeModalVisible" @close="selectSizeModalVisible=false" @confirm="updatePdfSettings"/>
    <!-- e::모달창 등록-->

  </div>


</template>
<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, ref, watch} from "vue";
import MypageSnb from "@/components/snb/MypageSnb.vue";
import PortfolioArtistProfile from "@/components/portfolio/PortfolioArtistProfile.vue";
import PdfGeneratePanel from "@/components/portfolio/PdfGeneratePanel.vue";
import PdfSelectSizeModal from "@/components/portfolio/PdfSelectSizeModal.vue";
import {apiClient} from "@/services/auth-header";
import PortfolioArtistArtWork from "@/components/portfolio/PortfolioArtistArtWork.vue";
import {useDeviceStore} from "@/store/deviceStore";
import {destroyTempBox} from "@/utils/tempBox";

const deviceStore = useDeviceStore();
const isMobile = computed(() => deviceStore.isMobile);

const loading = ref(true);

const PORTFOLIO = 'PORTFOLIO';
const portfolioTemplateName = ref('A4/가로');
const selectedIndex = ref(0)

const PdfGeneratePanelVisible = ref(false);
const selectSizeModalVisible = ref(false);

const visibleButtons = ref([
  {
    id: 0,
    label: '새 포트폴리오 만들기',
    handler: () => fetchPortfolio(),
  },
  {
    id: 1,
    label: '최근 포트폴리오 불러오기',
    date: '',
    handler: () => fetchSavedPortfolio(true),
  }
]);

const hasSavedPortfolio = ref(false)
const filteredButtons = computed(() => {
  return hasSavedPortfolio.value
      ? visibleButtons.value
      : visibleButtons.value.filter(btn => btn.id !== 1)
})

const pdfAutoDownload = ref(false);

const selectButton = async (index, handler) => {
  selectedIndex.value = index;
  handler?.(); // 함수 실행
}

const selectedArtist = ref(null);
const selectedArtWorks = ref(null);
const fieldVisibility = ref(null);
const profilePageLayoutConfig = ref(null);
const pdfSettingConfig = ref(null);
const reload = ref(false);

const openPdfGeneratePanel = () => {
  const hasPortfolioCategory = Array.isArray(selectedArtWorks.value)
      && selectedArtWorks.value.some(item => item.categoryUuid == PORTFOLIO);

  if (!hasPortfolioCategory) {
    const target = document.querySelector('.inner-box');
    if (target) {
      // 테두리 표시
      target.style.outline = '2px solid red';
      target.style.outlineOffset = '5px';
      target.style.borderRadius = '6px';

      setTimeout(() => {
        target.style.outline = '';
        target.style.outlineOffset = '';
        target.style.borderRadius = '';
      }, 3000);
    }

    alert("선택된 아트워크가 없습니다. 포트폴리오에 넣을 아트워크를 클릭한 후 리스트에 넣기 버튼을 눌러주세요.");
    return;
  }

  PdfGeneratePanelVisible.value = true;
}

const setPortfolioData = async (data) => {
  if (!data) {
    alert("데이터 로드 실패");
    return;
  }
  selectedArtist.value = {...data.artistProfile};
  selectedArtWorks.value = [...data.artistArtWorks];
  fieldVisibility.value = {...data.profileVisibility};
  profilePageLayoutConfig.value = {...data.profilePageLayoutConfig}
  pdfSettingConfig.value = {...data.pdfSettingConfig}
  reload.value = true;
}

const checkSavedPortfolio = async () => {
  try {
    const response = await apiClient.get('/v1/artists/me/portfolio/saved/exists');

    hasSavedPortfolio.value = response.data; // true 또는 false
    if (hasSavedPortfolio.value) {
      selectedIndex.value = 1;
    }
  } catch (error) {
    console.error('포트폴리오 존재 여부 확인 실패', error)
  }
}

const getLastUpdatedPortfolioDate = async () => {
  try {
    const response = await apiClient.get('/v1/artists/me/portfolio/saved/last-updated');

    if (response.data) {
      hasSavedPortfolio.value = true;
      visibleButtons.value[1].date = `(${response.data})`;
    }
  } catch (error) {
    console.error('포트폴리오 존재 여부 확인 실패', error)
  }
}

const fetchPortfolio = async () => {
  reload.value = false;
  try {
    const response = await apiClient.get('/v1/artists/me/portfolio/new');
    await setPortfolioData(response.data);
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    loading.value = false;
  }
};

const fetchSavedPortfolio = async (isTemporary = false) => {
  reload.value = false;
  try {
    alert(`최근 포트폴리오 제작 데이터를 불러옵니다.\n\n프로필과 아트워크를 업데이트 했다면, 최근 포트폴리오 제작 데이터에는 가장 최신 정보가 반영됩니다.`);

    const response = await apiClient.get('/v1/artists/me/portfolio/saved-with-latest-data', {params: {isTemporary}});
    await setPortfolioData(response.data);
    return true;
  } catch (error) {
    selectedIndex.value = 0;
    await selectButton(selectedIndex.value, visibleButtons.value[selectedIndex.value].handler);
    return false;
  } finally {
    loading.value = false;
  }
};

/* s: pdf size 설정*/
const updatePdfSettings = (newSettings) => {
  const [width, height] = newSettings.size;
  pdfSettingConfig.value.pageWidth = width;
  pdfSettingConfig.value.pageHeight = height;
  pdfSettingConfig.value.orientation = newSettings.orientation;
  portfolioTemplateName.value = newSettings.name;
};
/* e: pdf size 설정 */

/* s: 이미지 blob관리 */
const blobUrlMap = ref(new Map());

const revokeAllBlobUrls = () => {
  for (const url of blobUrlMap.value.values()) {
    URL.revokeObjectURL(url);
  }
  blobUrlMap.value.clear();
};

const checkRevokedBlobUrl = async (url) => {
  try {
    const res = await fetch(url)
    if (!res.ok) {
      throw new Error()
    }
    console.log('✅ blobUrl still valid')
  } catch {
    console.log('❌ blobUrl is revoked or invalid')
  }
}

onBeforeUnmount(async () => {
  revokeAllBlobUrls();
});

/* e: 이미지 blob관리 */

const initPortfolioData = async () => {
  //await fetchPortfolio();
  // await checkSavedPortfolio();
  await getLastUpdatedPortfolioDate();
  await selectButton(selectedIndex.value, visibleButtons.value[selectedIndex.value].handler);
}

onMounted(async () => {
  await initPortfolioData();
  loading.value = false;
  if (isMobile.value) {
    alert("포트폴리오 제작 기능은 PC 화면에 최적화되어 있어요. 모바일 접속 시 미리보기 화면과 실제 PDF 파일에 차이가 발생할 수 있습니다. 데스크톱이나 노트북으로 더 편리하게 이용하세요.");
  }
});

</script>

<style scoped>

.contents {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.portfolio-note-banner {
  position: sticky;
  top: 66px;
  background: #151419;
  color: #333;
  padding: 12px 16px;
  font-size: 14px;
  border: 1px solid #FF5C00;
  z-index: 10;
}

.note-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 3px;
}

.note-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 11px;
  height: 11px;
}

.note-title {
  font-family: 'SUIT';
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;

  color: #FF5C00;
}

.note-content {
  font-family: 'SUIT';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */
  color: #FFFFFF;
  width: 100%;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.note-mo {
  display: none;
}

.note-pc {
  display: block;
}

@media (max-width: 768px) {
  .note-header {
    margin-bottom: 3px;
  }

  .note-mo {
    display: block;
  }

  .note-pc {
    display: none;
  }
}


@media (max-width: 460px) {
  .portfolio-note-banner {
    top: 41px;
    padding: 6px 8px;
  }

  .note-content {
    font-size: 12px;
    line-height: 15px;
  }
}
</style>